import './BigDialStyles.css'
import React from 'react';
import { useEffect, useState } from 'react';

import darkGlobe from '../../Media/BigDial/BigDial-DarkGlobe04.svg';
// import brightGlobe from '../../Media/BigDial/BigDial-BrightGlobe06.svg';
import needle from '../../Media/BigDial/BigDial-Needle03.svg';
import middleNeedle from '../../Media/BigDial/BigDial-MiddleNeedle02.svg';
import powerCallout from '../../Media/BigDial/BigDial-PowerCallout06.svg';
import carbonCallout from '../../Media/BigDial/BigDial-CarbonCallout06.svg';

import {app} from '../../firebase/firebaseConfig';
import {getDatabase, ref, onValue} from "firebase/database";


const db = getDatabase(app);


const monthArray = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

function BigDial(props) {


  const [currentRotation, setCurrentRotation] = useState(0)
  const [currentEmissionOffset, setCurrentEmissionOffset] = useState(0)
  const [currentPowerVal, setCurrentPowerVal] = useState(0)
  const [currentPowerString, setCurrentPowerString] = useState('0')
  const [currentTemp, setCurrentTemp] = useState('0')
  const [queryTime, setQueryTime] = useState(['...Loading data', ''])
  
  

  useEffect(() => {
    const checkCurrentValue = ref(db, `${props.database}realtimeData/lastHour`);

    onValue(checkCurrentValue, (snapshot) => {
      
      const data = snapshot.val();
      const tvaMOER = data.lastValue.moer.TVA
      
      let ambientTemp = data.lastValue.ambientTemp
      
      ambientTemp = (ambientTemp * 1.8 + 32).toFixed(1)
      ambientTemp = ambientTemp.toString() + 'º FAHRENHEIT'
      setCurrentTemp(ambientTemp)
      
      let queryDate = new Date(data.queryTime)
      let displayDate = `${monthArray[queryDate.getMonth()]} ${queryDate.getDate()}, ${queryDate.getFullYear()}`
      let hours = queryDate.getHours()
      let ampm = ''
      if(hours >= 12){
        ampm = 'PM'
        
      } else {
        ampm = 'AM'
      }
      if(hours > 12){
        hours = hours % 12;
      }
      
      let minutes = queryDate.getMinutes().toString()
      if(minutes.length < 2){
        minutes = `0${minutes}`
      }
      

      let displayTime = `${hours}:${minutes} ${ampm} CT`
      setQueryTime([displayDate, displayTime]);
      
      let currentPower = data.summed.kwh
      // currentPower = currentPower
      // currentPower = currentPower.replace(/,/g, "")
      setCurrentPowerVal(currentPower)
      setCurrentPowerString(`${(currentPower / 1000).toFixed(2)}`)
      currentPower = currentPower / 1000
      
      // console.log(`currently offsetting ${Math.floor(tvaMOER * currentPower)} lbs of carbon`)
      const currentEmissions = tvaMOER * currentPower;
      if(currentEmissionOffset !== currentEmissions){
        setCurrentEmissionOffset(currentEmissions)
        
      }
      
    })
    

  }, [props.database, currentEmissionOffset]);

  
  const parseRotation = () => {
    let convertedRotation

    convertedRotation = currentRotation * (Math.PI / 180)

    const maxPower = 1000
    if(currentPowerVal < maxPower){
      convertedRotation =  ((currentPowerVal / maxPower) * 180)
    } else{
      convertedRotation = 180;
    }
    
    if (currentPowerVal <= 0){
      convertedRotation = 0;
    }


    if(convertedRotation !== currentRotation){
      setCurrentRotation(convertedRotation)
    }

  }

  const createDial = () =>{
    
    parseRotation()
    // convertedRotation = 160;
    // console.log(convertedRotation)
    
    // convertedRotation *= -1
    
    const svgSize = [100,100]


    const tPointTop = [
      50 + (50 * Math.cos((180 + currentRotation) * Math.PI/180)), 
      50 + (50 * Math.sin((180 + currentRotation) * Math.PI/180))
    ];
    const tPointBtm = [
      50 + (50 * Math.cos(currentRotation * Math.PI/180)), 
      50 + (50 * Math.sin(currentRotation * Math.PI/180))
    ];

    const showTemp = () => {
      if(props.displayName !== 'Jackson'){
        return(
            <p className='time-text' id="current-temp">{currentTemp}</p>
        )
      }
    }

    const showDot = () => {
      if(props.displayName !== 'Jackson'){
        return(
          <div className='circle-div'></div>
        )
      }
    }
      <div className='circle-div'></div>

    
    // console.log(currentRotation)
    return(
      <div id = 'canvas-container'>
          <div id='localization-text'>
            <h1 id='city-name'>{`${props.displayName ? props.displayName : 'Jackson'}, ${props.location ? props.location : 'Tennessee'}`}</h1>
            <div className='vert-div'></div>
            <p className='time-text'>{queryTime[0]}</p>
            <div className='circle-div'></div>
            <p className='time-text'>{queryTime[1]}</p>
            {showDot()}
            {showTemp()}
          </div>
          <svg viewBox={`0 0 ${svgSize[0]} ${svgSize[1]}`} xmlns="http://www.w3.org/2000/svg"  id = 'big-svg'>
            {/* <circle cx="50" cy="50" r="10" /> */}
            <g transform-origin='50 50' transform="translate(0,2.5) scale(1.15)">
              <image  href={darkGlobe} width="100" height="100"></image>

              <mask id='bright-mask'>
                
                <path d={`
                M ${svgSize[0]/2} ${svgSize[1]/2} 
                L ${tPointTop[0]} ${tPointTop[1]} 
                L ${svgSize[0]/2} 0
                L 0 0
                L 0 ${svgSize[1]/2}
                Z`} fill="white" style={{transition: 'd 1s'}}>
                </path>
                
                <path d={`
                M ${svgSize[0]/2} ${svgSize[1]/2} 
                L ${tPointBtm[0]} ${tPointBtm[1]} 
                L ${svgSize[0]/2} ${svgSize[1]} 
                L ${svgSize[0]} ${svgSize[1]} 
                L ${svgSize[0]} ${svgSize[1]/2} 
                Z`} fill="white" style={{transition: 'd 1s'}}/>
              </mask> 
              
              <image  href={props.brightGlobe} width="100" height="100" mask="url(#bright-mask)"></image>
              <image href={middleNeedle} width="100" height="100"> </image>
              {/* <g x='50' y='50' width='100' height='100'  transform={`rotate(${convertedRotation})`}>
                <image href={needle} width="100" height="100"> </image>
              </g> */}



              <g x='50' y='50' width='100' height='100' transform={`
                rotate(${currentRotation})
                translate(-30,${currentRotation < 90 ? '-9' : '9'})
                rotate(${ -1 * currentRotation})
              `} style={{transition: 'transform 1s'}}>
                <image href={powerCallout} width='100' height='100'/>
                <text x='50' y='50' textAnchor='middle' fontSize='2' className='call-out-text'>{currentPowerString}</text>
              </g>

              <g x='50' y='50' width='100' height='100' transform={`
                rotate(${currentRotation})
                translate(32,${currentRotation < 90 ? '14' : '-14'})
                rotate(${ -1 * currentRotation})
              `} style={{transition: 'transform 1s'}}>
                <image href={carbonCallout} width='100' height='100'/>
                <text x='50' y='50' textAnchor='middle' fontSize='2' className='call-out-text'>{Math.floor(currentEmissionOffset)}</text>
              </g>

              {/* <text x='15' y='3' textAnchor='left' fontSize='3' id='city-name'>{`Jackson, Tennessee`}</text>


              <text x='55' y='3' textAnchor='middle' fontSize='1.5' id='time-text'>{queryTime[0]}</text>
              <text x='71' y='3' textAnchor='middle' fontSize='1.5' id='time-text'>{queryTime[1]}</text>
              <text x='89' y='3' textAnchor='middle' fontSize='1.5' id='time-text'>{currentTemp}</text> */}

              <image href={needle} id='needle' className='globe-element' style={{transform: "rotate("+ currentRotation +"deg)", transition: 'transform 1s'}} alt='needle pointing at values'/>

            </g>
          </svg>         
            
            
        </div>
    )

  }

  

  return (
    <div className="flex-row space-around align-center w-100">
        
        {createDial()}


    </div>
    
  );
}

export default BigDial;





